import { AxiosError } from 'axios';

/**
 * Pull the server's own message out of a failed request.
 *
 * Every endpoint answers failures with `{ error: "..." }`, and every mutation
 * in the app used to throw that away in favour of a fixed string, so the user
 * was told that something failed but never why.
 */
export function apiError(err: unknown, fallback: string): string {
  const axiosErr = err as AxiosError<{ error?: string }> | undefined;

  const serverMessage = axiosErr?.response?.data?.error;
  if (typeof serverMessage === 'string' && serverMessage.trim()) return serverMessage;

  if (axiosErr?.code === 'ERR_NETWORK') return 'Cannot reach the server. Check your connection.';
  if (axiosErr?.response?.status === 403) return 'You do not have permission to do that.';
  if (axiosErr?.response?.status === 429) return 'Too many requests — wait a moment and try again.';

  return fallback;
}
